/**
 * Button types
 *
 * @return {string[]}
 */

export const BORDER_RADIUS = [0, 2, 4, 8, 12, 16, 20, 24, 28];

export const LAYOUTS = ['right-icon', 'left-icon', 'no-icon', 'only-icon'];

export const TYPES = [
    'main',
    'lime',
    'action', // backward-compatible alias for 'lime' (styled by the same CSS)
    'secondary',
    'inverse',
    'inverse-white',
    'ghost',
    'ai-gradient',
];

export const SIZES = ['s', 'm', 'large', 'medium', 'small', 'tiny', 'micro'];

export const ALIGNMENTS = ['center', 'start', 'end', 'between'];

export default {};
